import { useEffect, useState } from "react";
import { getPrincipalMessage } from "../Service/Api";
import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import LazyLoad from "react-lazyload";
const removeHtmlTags = (str) => {
  return str.replace(/<[^>]*>/g, ""); // Removes anything between '<' and '>'
};
const Manager = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);
  const emptyArray = [
    // { description: "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.", attachments: "director.jpg" },
  ];
  return (
    <>
      <Breadcrumb
        breadtitle="Manager Message"
        breadmid="About"
        breadend="Manager Message"
      />
      <div className="innerpage">
        <div className="container">
          {data?.length > 0 ? (
            data
              ?.filter((div) => div.category === "Manager")
              .map((item, index) => (
                <div className="row message_inner" key={index}>
                  <div className="col-lg-4 col-md-4">
                    <LazyLoad>
                      <img
                        src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`}
                        className="inner_img img-fluid"
                        alt="Cannosa School, Lucknow"
                      />
                    </LazyLoad>
                  </div>
                  <div className="col-lg-8 col-md-8 messagebox">
                    <p>{removeHtmlTags(item.message)}</p>
                    <h5 className="mb-0">{item.name} </h5>
                    <h5>
                      <span> {item.category} </span>
                    </h5>
                    <div className="clr"></div>
                  </div>
                </div>
              ))
          ) : (
            <div className="row">
              <div className="row message_inner">
                <div className="col-lg-4 col-md-4">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/manager.png"
                      className="inner_img img-fluid"
                      alt="Canossa School, Lucknow"
                    />
                  </LazyLoad>
                </div>
                <div className="col-lg-8 col-md-8 messagebox">
                  <p>
                    <b>
                      Dear Parents, teachers’ , well wishers and all my
                      wondecontainer-fluidul students.
                    </b>
                  </p>
                  <p>
                    “Education is a shared commitment between dedicated
                    teachers, motivated students and enthusiastic parents with
                    high expectations.”
                  </p>
                  <p>
                    I thank Almighty God for his innumerable graces bestowed
                    upon us, that has always led this institution from the time
                    of inception. “From untruth to truth” as our motto we have
                    been scaling great heights in shaping the young minds who
                    have imbibed honesty , integrity, righteousness and loyalty
                    towards their nation and mother Earth.
                  </p>
                  <p>
                    Canossa family has always marched focontainerard gaining
                    strength and knowledge from the daily experiences of life,
                    and which has, in return, enhanced quality education and
                    fostering character formation. Our education also ensures
                    all round development of the students and grooming them as
                    conscious, human being, leading them to become responsible
                    citizens of our country, and would be entrusted as agents of
                    social justice and societal transformation in their own work
                    place and make a relevant difference in the society.
                  </p>
                  <p>
                    Covid 19 has compelled each one of us for self isolation,
                    social distancing along with numerous worowies, challenges
                    and pain of losing our loved ones. These have left us with
                    disrupted normal life and even the road ahead is yet
                    unknown. I understand the challenges faced by everyone to
                    cater to the academic needs due to the closure of school and
                    adapting to virtual learning. But I am proud of all the
                    parents, teachers and students who have demonstrated
                    diligence, motivation and ovecontainerhelming determination
                    to work to the best of their abilities to learn new ways and
                    methods . We shouldn’t let the pandemic pin us down. We must
                    remain positive and keep our spirits high and hopes alive as
                    I believe that “ Nothing is predestined. The obstacles of
                    our past can become the gateways that lead to new
                    beginnings.
                  </p>
                  <p>
                    <b>God Bless You all.</b>
                  </p>
                  <h5 className="mb-0">Sr. Philomena Lobo </h5>
                  <h5>
                    <span>Manager</span>
                  </h5>
                  <div className="clr"></div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Manager;
